import type { VariantWithTemplateSelectFragment } from '~/api/graphql/fragments/variant.generated';
import type { Campaign } from '~/types/graphql';

import { useHandleEditTemplate } from './useHandleEditTemplate';

export interface RepublishActionData {
  campaign: Campaign;
  variant: VariantWithTemplateSelectFragment;
}

export const useUnpublishedTemplateActions = () => {
  const { onEditWithTemplate } = useHandleEditTemplate();

  const openPageToRepublish = async (data: RepublishActionData) => {
    const { campaign, variant } = data;
    onEditWithTemplate(variant, campaign);
  };

  // const openPageToRepublish = async (data: RepublishActionData) => {
  //   const { campaign, variant } = data;
  //   const themePageId = variant.themePageID;

  //   onEditWithTemplate(variant, campaign);

  //   listenWebSocketPublish(({ Data }) => {
  //     if (Data?.ThemePageID !== themePageId) return;

  //     if (Data?.Status === 'SUCCESS') {
  //       window.location.reload();
  //       removeListenPublishSocket();
  //       return;
  //     }
  //   });
  // };

  // useEffect(() => {
  //   if (!isOpenModalPublishCampaign) return;

  //   removeListenPublishSocket();
  //   return () => {
  //     removeListenPublishSocket();
  //   };
  // }, [isOpenModalPublishCampaign]); //eslint-disable-line

  return {
    openPageToRepublish,
  };
};
